import AppCatalog from "@/services/App/AppCatalog.js";
import Catalog from "./StockTrfCatalog.js"
import Model from "./StockTrfModel.js";

export default {
  Message: {
    Details_ParamIncomplete:
      AppCatalog.Message.ParamIncomplete,
    New_ConfirmDeleteItem:
      "Yakin menghapus " + Model.StockTrfItem.Module.FullName + "?",
    New_Details:
      "Tidak diperkenankan mengubah " + Catalog.SourceWarehouseID.Label + ", " +
      "saat sudah memiliki " + Model.StockTrfItem.Module.FullName + ".",
    New_Items:
      "Harap mengisi " + Catalog.SourceWarehouseID.Label + ", " +
      "sebelum memilih " + Model.StockTrfItem.Module.FullName + ".",
    PrintDetails_ParamIncomplete:
      AppCatalog.Message.ParamIncomplete
  },
  Tabs: {
    Details: Model.ModuleType.Details.Name
  }
}